import { render, staticRenderFns } from "./BtnAjustarBoleto.vue?vue&type=template&id=3c9d27bc"
import script from "./BtnAjustarBoleto.vue?vue&type=script&lang=js"
export * from "./BtnAjustarBoleto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports